import CoverSearch from 'src/components/CoverSearch'

import { CoverSectionProps } from '../../components/CoverSection'
import Breadcrumb, { BreadcrumbProps } from '../../components/Breadcrumb'
import { colors } from '../../theme'

export const recipesCoverTransformer = (params: {
  t: any
  breadcrumbItems: BreadcrumbProps
  onSearch?: (value: string) => void
  backgroundImageDesktop?: string
  backgroundImageMobile?: string
  backgroundImageAlt?: string
  initialValue?: string
  tag?: string
}): CoverSectionProps => {
  const {
    t,
    breadcrumbItems,
    onSearch,
    backgroundImageDesktop,
    backgroundImageMobile,
    backgroundImageAlt,
    initialValue,
    tag,
  } = params
  return {
    title: tag
      ? t('recipes_by_tag_cover_title', { tag })
      : t('recipes_cover_title'),
    backgroundColor: colors.greenEmerald,
    backgroundImageMobile: {
      src: backgroundImageMobile ?? '',
      layout: 'fill',
      objectFit: 'cover',
      alt: backgroundImageAlt ?? '',
    },
    backgroundImageDesktop: {
      src: backgroundImageDesktop ?? '',
      layout: 'fill',
      objectFit: 'cover',
      alt: backgroundImageAlt ?? '',
    },
    breadcrumb: (
      <>
        <Breadcrumb
          hoverColor={colors.greenEmerald}
          links={breadcrumbItems.links}
        />
      </>
    ),
    ...(onSearch && {
      bottomContent: (
        <>
          <CoverSearch
            placeholder={t('recipes_cover_search_cta')}
            onSearch={onSearch}
            initialValue={initialValue}
          />
        </>
      ),
    }),
  }
}
